
(function ($, d, ns) {
    ns.initActivator = function () {

        $('.js-activator').on('click', function (e) {
            $('.js-activator.active').removeClass('active');
            $(this).addClass('active');
        });
    }

    $(d).ready(function () {
        ns.initActivator();
    });

})(jQuery, document, Crafted.Utilities);